export default class User {
  constructor(properties, token) {
    this.properties = properties;
    this.token = token;
  }
}
